import { RETURNS_INTAKE_STATUS_LABELS as STATUS_LABELS, RETURNS_INTAKE_STATUS_CLASSES as STATUS_CLASSES } from '../../config/statusChip';
import { Assignment as ReportIcon, CheckCircle as CheckIcon } from '@mui/icons-material';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { GlobalButton } from '@/components';
import { appUrl } from '@/utils/appUrl';

interface SummaryBriefProps {
  driverName?: string;
  driverId?: string;
  routeName?: string;
  routeId?: string;
  title?: string;
  routeLabel?: string;
  status?: string;
  onFinish?: () => void;
  isProcessing?: boolean;
}

const SummaryBrief = ({
  driverName,
  driverId,
  routeName,
  routeId,
  title = 'Reporte de Rendición',
  routeLabel = 'Hoja de Ruta',
  status,
  onFinish,
  isProcessing
}: SummaryBriefProps) => {

  const handleDriverClick = () => {
    if (driverId) {
      window.open(appUrl(`/business/drivers/${driverId}`), '_blank');
    }
  };

  const handleRouteClick = () => {
    if (routeId) {
      window.open(appUrl(`/business/monitoring/${routeId}`), '_blank');
    }
  };

  return (
    <div className='bg-white rounded-2xl border border-gray-100 p-8 shadow-sm flex justify-between items-center'>
      <div className='flex items-center gap-6'>
        <div className='w-16 h-16 bg-orange-50 flex items-center justify-center rounded-2xl'>
          <ReportIcon className='text-[#ff7500] text-[32px]' />
        </div>
        <div className='flex flex-col mt-3'>
          {routeName && (
            <div className='flex items-center gap-2 mb-1'>
              <span className='text-[12px] text-slate-400 font-extrabold uppercase tracking-[0.2em]'>
                {routeLabel}
              </span>
              <span
                onClick={handleRouteClick}
                className={`text-blue-600 font-black uppercase tracking-wider text-[12px] ${routeId ? 'cursor-pointer hover:underline' : ''}`}
              >
                {routeName}
              </span>
            </div>
          )}
          <h1 className='text-2xl font-black text-slate-800 tracking-tight'>
            {title}
            {driverName && (
              <span
                onClick={handleDriverClick}
                className={`ml-2 text-orange-600 ${driverId ? 'cursor-pointer hover:underline' : ''}`}
              >
                {driverName}
              </span>
            )}
          </h1>
        </div>
      </div>
      <div className='flex items-center gap-4'>
        {status && (
          <span className={`px-5 py-2 rounded-xl text-base font-black ${STATUS_CLASSES[status] || 'bg-gray-100 text-gray-800'}`}>
            {STATUS_LABELS[status] || status}
          </span>
        )}
        {onFinish && (
          <GlobalButton
            variant={GlobalButtonVariant.secondaryButton}
            action={onFinish}
            disabled={isProcessing}
            size='large'
          >
            <CheckIcon className='mr-2 text-[18px] text-[#ff7500]' />
            Cerrar Rendición
          </GlobalButton>
        )}
      </div>
    </div>
  );
};

export default SummaryBrief;
